/* Minimal stroke-icon set (24x24, currentColor) + small UI atoms */
const Icon = ({ d, fill, size = 18, sw = 1.7, children, className, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill || 'none'}
    stroke={fill ? 'none' : 'currentColor'} strokeWidth={sw} className={className} style={style}
    strokeLinecap="round" strokeLinejoin="round">
    {d ? <path d={d} /> : children}
  </svg>
);

const I = {
  home:    (p) => <Icon {...p} d="M3 10.5 12 3l9 7.5M5 9.5V20h14V9.5" />,
  builds:  (p) => <Icon {...p}><rect x="3" y="4" width="18" height="5" rx="1.5"/><rect x="3" y="11.5" width="18" height="5" rx="1.5"/><path d="M7 6.5h.01M7 14h.01"/></Icon>,
  add:     (p) => <Icon {...p} d="M12 5v14M5 12h14" />,
  copy:    (p) => <Icon {...p}><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h8"/></Icon>,
  review:  (p) => <Icon {...p}><path d="M9 11.5l2 2 4-4.5"/><rect x="3" y="3.5" width="18" height="17" rx="3"/></Icon>,
  kb:      (p) => <Icon {...p} d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15.5H6.5A2.5 2.5 0 0 0 4 21V5.5ZM4 5.5A2.5 2.5 0 0 0 6.5 8H20" />,
  usage:   (p) => <Icon {...p}><path d="M4 19V5M4 19h16M8 16l3-4 3 2 4-6"/></Icon>,
  settings:(p) => <Icon {...p}><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1"/></Icon>,
  search:  (p) => <Icon {...p}><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></Icon>,
  bell:    (p) => <Icon {...p} d="M6 9a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6M10 21h4" />,
  chevron: (p) => <Icon {...p} d="M9 6l6 6-6 6" />,
  menu:    (p) => <Icon {...p} d="M3.5 6h17M3.5 12h17M3.5 18h17" />,
  arrow:   (p) => <Icon {...p} d="M5 12h14M13 6l6 6-6 6" />,
  download:(p) => <Icon {...p} d="M12 4v11m0 0l-4-4m4 4l4-4M5 19h14" />,
  doc:     (p) => <Icon {...p}><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5"/></Icon>,
  image:   (p) => <Icon {...p}><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9" r="1.5"/><path d="M21 16l-5-5L5 20"/></Icon>,
  code:    (p) => <Icon {...p} d="M8 8l-4 4 4 4M16 8l4 4-4 4" />,
  json:    (p) => <Icon {...p} d="M8 4C5.5 4 6 9 4 12c2 3 1.5 8 4 8M16 4c2.5 0 2 5 4 8-2 3-1.5 8-4 8" />,
  zip:     (p) => <Icon {...p}><path d="M7 3h10v18H7z"/><path d="M11 3v2M13 5v2M11 7v2M13 9v2M11 11v2"/></Icon>,
  figma:   (p) => <Icon {...p}><path d="M12 3H8.5a3 3 0 0 0 0 6H12m0-6h3.5a3 3 0 0 1 0 6H12m0 0H8.5a3 3 0 1 0 0 6H12m0-6v6m0 0v3a3 3 0 1 1-3-3"/></Icon>,
  pdf:     (p) => <Icon {...p}><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5"/><path d="M9.5 13.5h1a1 1 0 0 1 0 2h-1zM9.5 17v-3.5"/></Icon>,
  psd:     (p) => <Icon {...p}><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M8 15v-6h1.5a1.5 1.5 0 0 1 0 3H8M15 9.5a4 4 0 0 0 0 5"/></Icon>,
  check:   (p) => <Icon {...p} d="M5 12.5l4.5 4.5L19 6.5" />,
  x:       (p) => <Icon {...p} d="M6 6l12 12M18 6L6 18" />,
  warn:    (p) => <Icon {...p}><path d="M12 9v4.5M12 17h.01"/><path d="M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/></Icon>,
  retry:   (p) => <Icon {...p} d="M4 12a8 8 0 1 1 2.3 5.6M4 18v-4h4" />,
  cancel:  (p) => <Icon {...p}><circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/></Icon>,
  coins:   (p) => <Icon {...p}><ellipse cx="12" cy="6" rx="7" ry="3"/><path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6"/></Icon>,
  bolt:    (p) => <Icon {...p} fill="currentColor" d="M13 2 4 14h6l-1 8 9-12h-6z" />,
  flame:   (p) => <Icon {...p} d="M12 3c.6 3.2 3.8 4.2 3.8 8a3.8 3.8 0 1 1-7.6 0c0-1.1.4-2 .9-2.8.5 1.1 1.1 1.6 2 1.7C10.4 7.6 10.8 5 12 3Z" />,
  clock:   (p) => <Icon {...p}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></Icon>,
  layers:  (p) => <Icon {...p} d="M12 3 3 8l9 5 9-5-9-5ZM3 13l9 5 9-5M3 17.5l9 5 9-5" />,
  cmd:     (p) => <Icon {...p} d="M9 6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3z" />,
  shield:  (p) => <Icon {...p} d="M12 3l7 2.6V11c0 4.8-3.3 7.8-7 9.4C8.3 18.8 5 15.8 5 11V5.6z" />,
  key:     (p) => <Icon {...p}><circle cx="7.5" cy="15.5" r="3.8"/><path d="M10.2 12.8 20 3M16.5 6.5 19 9M14 9l2 2"/></Icon>,
  users:   (p) => <Icon {...p}><circle cx="9" cy="8" r="3.2"/><path d="M3.5 20a5.5 5.5 0 0 1 11 0"/><path d="M15.8 5.3a3.2 3.2 0 0 1 0 6.4M17 20a5.5 5.5 0 0 0-3-4.9"/></Icon>,
  star:    (p) => <Icon {...p} d="M12 3.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L12 17l-5.2 2.7 1-5.8L2.6 9.7l5.8-.8z" />,
  flag:    (p) => <Icon {...p} d="M5 21V4M5 4h11l-2 3.2 2 3.2H5" />,
  trash:   (p) => <Icon {...p}><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13M10 11v6M14 11v6"/></Icon>,
  building:(p) => <Icon {...p}><path d="M4 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16M14 21V10h5a1 1 0 0 1 1 1v10M2 21h20M7 8h2M7 12h2M7 16h2"/></Icon>,
  lock:    (p) => <Icon {...p}><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></Icon>,
  sound:   (p) => <Icon {...p}><path d="M4 9v6h4l5 4V5L8 9H4Z"/><path d="M16 8.5a4 4 0 0 1 0 7M18.5 6a7 7 0 0 1 0 12"/></Icon>,
  mute:    (p) => <Icon {...p}><path d="M4 9v6h4l5 4V5L8 9H4Z"/><path d="M22 9l-6 6M16 9l6 6"/></Icon>,
  tag:     (p) => <Icon {...p}><path d="M3.5 11.5 11 4h7.5V11.5L11 19z"/><circle cx="14.5" cy="8.5" r="1.4" fill="currentColor" stroke="none"/></Icon>,
  link:    (p) => <Icon {...p} d="M10 13.5a3.5 3.5 0 0 0 5 0l3-3a3.5 3.5 0 0 0-5-5l-1.5 1.5M14 10.5a3.5 3.5 0 0 0-5 0l-3 3a3.5 3.5 0 0 0 5 5l1.5-1.5" />,
  chat:    (p) => <Icon {...p} d="M21 11.5a8 8 0 0 1-11.5 7.2L4 20.5l1.8-5.3A8 8 0 1 1 21 11.5Z" />,
  send:    (p) => <Icon {...p} d="M4 12 20 4l-6 16-3-7z M11 13l9-9" />,
  calendar:(p) => <Icon {...p}><rect x="4" y="5" width="16" height="16" rx="2.5"/><path d="M4 9.5h16M8 3v4M16 3v4"/></Icon>,
  sun:     (p) => <Icon {...p}><circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2.4M12 19.1v2.4M4.2 4.2l1.7 1.7M18.1 18.1l1.7 1.7M2.5 12h2.4M19.1 12h2.4M4.2 19.8l1.7-1.7M18.1 5.9l1.7-1.7"/></Icon>,
  moon:    (p) => <Icon {...p} d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" />,
  terminal:(p) => <Icon {...p}><rect x="3" y="4" width="18" height="16" rx="2.5"/><path d="M7 9l3 3-3 3M13 15h4"/></Icon>,
  jet:     (p) => <Icon {...p} d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 4.8c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />,
  // Filled airplane from the New Build handoff (icons.jsx `jet`, 2026-09-24): the Sabre agent tile. The outline `jet` above stays for Chase/codex-usage.
  jetSolid: (p) => <Icon {...p} fill="currentColor" d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />,
};

// StatusPill — status (pipeline state) and verdict (QA rating) are DISTINCT
// concerns; render them so an operator can tell at a glance what to do:
//   status='failed' (pipeline broke mid-run)   → "Pipeline failed" (red, restart needed)
//   status='running'/'queued'                   → spinner / queued
//   status='needs_review'                       → "Needs review" (cond, awaiting human)
//   status='complete' + verdict='PASS'          → "Passed" (green, shipped)
//   status='complete' + verdict='FAIL'          → "QA failed" (red, NOT pipeline-broken —
//                                                 re-run from execute or reject is the move)
//   status='complete' + verdict='CONDITIONAL'   → "Conditional" (amber)
// data-status / data-verdict attrs let smokes assert which branch fired.
function StatusPill({ status, verdict }) {
  const attrs = { 'data-status': status || '', 'data-verdict': verdict || '' };
  if (status === 'running')  return <span className="pill pill-run" {...attrs}><span className="dot"></span>Running</span>;
  if (status === 'queued')   return <span className="pill pill-queued" {...attrs}><span className="dot"></span>Queued</span>;
  // ⚠️ TRUE pipeline failure — distinct copy + warn icon so the operator knows to restart
  if (status === 'failed')   return <span className="pill pill-fail" title="Pipeline broke mid-run. Restart from the failed stage." {...attrs}><I.warn size={11}/>Pipeline failed</span>;
  if (status === 'needs_review') return <span className="pill pill-cond" {...attrs}><I.warn size={11}/>Needs review</span>;
  // Verdict-driven (pipeline completed): PASS green, FAIL red dot (no warn icon → distinct from pipeline-failed)
  if (status === 'complete' && verdict === 'PASS') return <span className="pill pill-pass" {...attrs}><span className="dot"></span>Passed</span>;
  if (status === 'complete' && verdict === 'FAIL') return <span className="pill pill-fail" title="Build completed; QA scored it FAIL (or it was rejected on review)." {...attrs}><span className="dot"></span>QA failed</span>;
  if (status === 'complete' && verdict === 'CONDITIONAL') return <span className="pill pill-cond" {...attrs}><I.warn size={11}/>Conditional</span>;
  if (status === 'complete') return <span className="pill pill-pass" {...attrs}><span className="dot"></span>Complete</span>;
  // Legacy mock fallbacks (mock job data uses verdict alone)
  if (verdict === 'PASS')         return <span className="pill pill-pass" {...attrs}><span className="dot"></span>Passed</span>;
  if (verdict === 'CONDITIONAL')  return <span className="pill pill-cond" {...attrs}><I.warn size={11}/>Needs review</span>;
  if (verdict === 'FAIL')         return <span className="pill pill-fail" {...attrs}><span className="dot"></span>QA failed</span>;
  return <span className="pill pill-queued" {...attrs}><span className="dot"></span>{status || 'unknown'}</span>;
}

function ClientBadge({ slug, size = 28 }) {
  const c = window.MAV.clientBySlug(slug);
  if (!c) return null;
  return <div className="client-logo" style={{ background: c.color, width: size, height: size, fontSize: size * 0.4, borderRadius: size * 0.27 }}>{c.initials}</div>;
}

function Swatches({ colors }) {
  return <div className="swatch-row">{colors.map((c, i) => <span key={i} className="swatch" style={{ background: c }}></span>)}</div>;
}

/* Goose mascot — theme-aware. Light: envelope courier. OLED: monochrome
   silhouette. Console: goose at a terminal with green code.
   "Every Maverick needs a Goose." */
function GooseLight({ size = 26 }) {
  const ink = '#1B1B1B', orange = '#FF7A18', white = '#FFFFFF';
  return (
    <svg width={size} height={size} viewBox="0 0 44 40" fill="none"
      stroke={ink} strokeWidth="1.7" strokeLinejoin="round" strokeLinecap="round">
      <path d="M24 27.5 L23 33 M23 33 L20.5 33.4 M23 33 L25 34" stroke={orange} strokeWidth="1.9" />
      <path d="M30 28 L31.5 33 M31.5 33 L29 33.6 M31.5 33 L34 33.6" stroke={orange} strokeWidth="1.9" />
      <path fill={white} d="M39 17C36 9 31 7 25 8C22 8.5 20 10 19 13C16 14 12 15 10 17C7.5 18.5 6.5 21 8 23C9.5 25 12.5 25 14 22.5C15 21 16 21.5 17.5 22.5C21 25.5 27 27.5 33 25.5C37 24 39 20.5 39 17Z" />
      <path d="M30 14C32.5 16 33 20 31 23.5" stroke={ink} strokeWidth="1.4" fill="none" />
      <path d="M8.5 19.6 L2.5 20.8 L8.5 22.8 Z" fill={orange} stroke={orange} />
      <g transform="rotate(-10 4.5 21)">
        <rect x="-0.2" y="16.6" width="9" height="6.5" rx="1" fill={white} stroke={ink} strokeWidth="1.5" />
        <path d="M0.1 17.3 L4.3 20.2 L8.5 17.3" fill="none" stroke={orange} strokeWidth="1.4" />
      </g>
      <circle cx="10.6" cy="20.2" r="1.1" fill={ink} stroke="none" />
    </svg>
  );
}

/* OLED — monochromatic: one tone, no envelope, minimal detail */
function GooseOLED({ size = 26 }) {
  const w = '#F4F2EA';
  return (
    <svg width={size} height={size} viewBox="0 0 44 40" fill="none"
      strokeLinejoin="round" strokeLinecap="round">
      <path d="M24 27.5 L23 33 M23 33 L20.5 33.4 M23 33 L25 34" stroke={w} strokeWidth="1.9" />
      <path d="M30 28 L31.5 33 M31.5 33 L29 33.6 M31.5 33 L34 33.6" stroke={w} strokeWidth="1.9" />
      <path fill={w} stroke="none" d="M39 17C36 9 31 7 25 8C22 8.5 20 10 19 13C16 14 12 15 10 17C7.5 18.5 6.5 21 8 23C9.5 25 12.5 25 14 22.5C15 21 16 21.5 17.5 22.5C21 25.5 27 27.5 33 25.5C37 24 39 20.5 39 17Z" />
      <path d="M8.5 19.6 L2.5 20.8 L8.5 22.8 Z" fill={w} stroke={w} />
      <path d="M30 14C32.5 16 33 20 31 23.5" stroke="rgba(0,0,0,0.32)" strokeWidth="1.3" fill="none" />
      <circle cx="10.6" cy="20.2" r="1.05" fill="#141414" stroke="none" />
    </svg>
  );
}

/* Console — goose at a CRT terminal, green code on a dark screen */
function GooseConsole({ size = 26 }) {
  const green = '#46E6A0', screen = '#06120D', goose = '#EDEFE8', orange = '#FF7A18', ink = '#0C1A14';
  return (
    <svg width={size} height={size} viewBox="0 0 44 40" fill="none"
      strokeLinejoin="round" strokeLinecap="round">
      {/* desk line */}
      <path d="M3 35 H41" stroke="rgba(70,230,160,0.35)" strokeWidth="1.4" />
      {/* monitor */}
      <rect x="21" y="7.5" width="20" height="16" rx="2" fill={screen} stroke="rgba(70,230,160,0.55)" strokeWidth="1.2" />
      <path d="M31 23.5 V27.5 M27 27.5 H35" stroke={goose} strokeWidth="1.6" />
      {/* green code lines + cursor */}
      <g stroke={green} strokeWidth="1.5">
        <path d="M24 12 H32" />
        <path d="M24 15.2 H37" />
        <path d="M24 18.4 H29" />
      </g>
      <rect x="30.5" y="17.1" width="2.6" height="2.6" fill={green} />
      {/* goose body */}
      <ellipse cx="11" cy="25.6" rx="7.6" ry="6" fill={goose} />
      {/* neck (thick rounded stroke) curving toward the screen */}
      <path d="M13 22 C14.5 16.5 16 14 18.6 13" stroke={goose} strokeWidth="4.6" fill="none" strokeLinecap="round" />
      {/* head */}
      <circle cx="19" cy="12.6" r="3.1" fill={goose} />
      {/* beak toward screen */}
      <path d="M21.7 12.2 L25.2 13.1 L21.7 14.2 Z" fill={orange} />
      {/* eye */}
      <circle cx="19.7" cy="12" r="0.85" fill={ink} />
      {/* legs */}
      <path d="M9 31.2 V35 M13 31.2 V35" stroke={orange} strokeWidth="1.5" />
      {/* wing hint */}
      <path d="M7.8 25 C11 27.6 14 27 15.6 23.4" stroke="rgba(12,26,20,0.28)" strokeWidth="1.2" fill="none" />
    </svg>
  );
}

function GooseMark({ size = 26 }) {
  const [theme, setTheme] = React.useState(() => (window.GooseTheme ? window.GooseTheme.get() : 'light'));
  React.useEffect(() => {
    const h = (e) => setTheme(e.detail);
    window.addEventListener('goose-theme-change', h);
    return () => window.removeEventListener('goose-theme-change', h);
  }, []);
  if (theme === 'console') return <GooseConsole size={size} />;
  if (theme === 'dark') return <GooseOLED size={size} />;
  return <GooseLight size={size} />;
}

Object.assign(window, { Icon, I, StatusPill, ClientBadge, Swatches, GooseMark });

/* Fullscreen render lightbox — shared by Review + Afterburner image slots.
   Double-click a slot to enlarge. Shows the real <img> if a src has been
   provided, else an enlarged clone of the placeholder render. */
function openRenderLightbox(vizEl, caption) {
  if (!vizEl) return;
  var prev = document.getElementById('rs-lightbox'); if (prev) prev.remove();
  var ov = document.createElement('div'); ov.id = 'rs-lightbox'; ov.className = 'rs-lightbox';
  var inner = document.createElement('div'); inner.className = 'rs-lightbox-inner';
  var img = vizEl.querySelector && vizEl.querySelector('img[data-render]');
  if (img && img.getAttribute('src')) {
    var big = document.createElement('img'); big.src = img.getAttribute('src'); big.className = 'rs-lightbox-img'; inner.appendChild(big);
  } else {
    var clone = vizEl.cloneNode(true); clone.classList.add('rs-bigclone'); inner.appendChild(clone);
  }
  ov.appendChild(inner);
  if (caption) { var cap = document.createElement('div'); cap.className = 'rs-lightbox-cap'; cap.textContent = caption; ov.appendChild(cap); }
  var hint = document.createElement('div'); hint.className = 'rs-lightbox-hint'; hint.textContent = 'click anywhere · Esc to close'; ov.appendChild(hint);
  function close() { ov.remove(); document.removeEventListener('keydown', onkey); }
  function onkey(e) { if (e.key === 'Escape') close(); }
  ov.addEventListener('click', close); document.addEventListener('keydown', onkey);
  document.body.appendChild(ov);
}
window.openRenderLightbox = openRenderLightbox;
